export const dashboardSummaryMockData = [
  {
    date: '2026-09-01T00:00:00.000Z',
    year: 2026,
    month: 9,
    tce: 21455.37,
  },
  {
    date: '2026-10-01T00:00:00.000Z',
    year: 2026,
    month: 10,
    tce: 22870.12,
  },
]
